module.exports = __webpack_public_path__ + "static/fonts/iconfont.6f91b9b0.woff";